import { MerchantCatalogProductsApi } from '../openapi';
import { config } from './config';

export const CatalogProductsClient = new MerchantCatalogProductsApi(config);
